/* Optional-additions section on a create proposal card. Deliberately neutral
   (no mint) so it never competes with the card's single accent — the primary
   Approve action. Reads the same in light and dark via --rv-* tokens. */

.Additions {
  display: grid;
  gap: var(--rv-space-2);
  padding: var(--rv-space-3);
  border: 1px dashed var(--rv-border);
  border-radius: var(--rv-radius-lg);
  background: var(--rv-bg-app-subtle);
}

.Head {
  display: flex;
  align-items: center;
  gap: var(--rv-space-1);
  font-family: var(--rv-font-sans);
  font-size: var(--rv-text-xxs);
  font-weight: var(--rv-w-bold);
  letter-spacing: var(--rv-track-wide);
  text-transform: uppercase;
  color: var(--rv-fg-4);
}

.Head svg {
  width: var(--rv-icon-xs);
  height: var(--rv-icon-xs);
}

.List {
  display: grid;
  gap: var(--rv-space-1);
  margin: 0;
}

.Row {
  display: flex;
  align-items: baseline;
  gap: var(--rv-space-3);
}

.Label {
  flex: 0 0 auto;
  min-width: var(--rv-space-20);
  font-size: var(--rv-text-xs);
  font-weight: var(--rv-w-semibold);
  color: var(--rv-fg-1);
}

.Hint {
  margin: 0;
  font-size: var(--rv-text-xs);
  color: var(--rv-fg-3);
  overflow-wrap: anywhere;
}

.Note {
  margin: 0;
  font-size: var(--rv-text-xxs);
  color: var(--rv-fg-4);
}

/* Picker mode — each element gets an "Add" action so the user can choose one. */
.Options {
  display: grid;
  gap: var(--rv-space-2);
  margin: 0;
}

.OptionRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--rv-space-3);
}

.OptionText {
  display: grid;
  gap: var(--rv-space-1);
}

.OptionLabel {
  font-size: var(--rv-text-xs);
  font-weight: var(--rv-w-semibold);
  color: var(--rv-fg-1);
}

.OptionHint {
  font-size: var(--rv-text-xs);
  color: var(--rv-fg-3);
  overflow-wrap: anywhere;
}

.Add {
  flex: 0 0 auto;
}
